import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& button + button': {
      marginLeft: theme.spacing(3),
    },
    margin: theme.spacing(4, 0),
  },
}));

export default useStyles;
